import type { DataTableColumn } from '@/components/custom/erp';
import type { ViTriKho } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<ViTriKho>[] => {
  return [
    {
      field: 'kho_code',
      headerName: 'Mã kho',
      width: 120,
      renderCell: params => {
        return params.row.ma_kho_data?.ma_kho || '';
      }
    },
    {
      field: 'kho_name',
      headerName: 'Tên kho',
      width: 250,
      renderCell: params => {
        return params.row.ma_kho_data?.ten_kho || '';
      }
    },
    {
      field: 'ma_vi_tri',
      headerName: 'Mã vị trí',
      width: 120
    },
    {
      field: 'ten_vi_tri',
      headerName: 'Tên vị trí',
      width: 250
    }
  ];
};
